import { render, staticRenderFns } from "./label1Modal.vue?vue&type=template&id=268543ca&scoped=true"
import script from "./label1Modal.vue?vue&type=script&lang=js"
export * from "./label1Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268543ca",
  null
  
)

export default component.exports